'use strict';

module.exports = {
  payloadKeySeparator: '?', // used for notifications with multiple payloadKeys. e.g. workpackage_id?level_entry_keys or workpackage_id?skip_optimisation.
  payloadValueJoiner: '::', // used for notifications with multiple values for a single payloadKey. e.g. level_entry_keys
};